var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rows", attrs: { id: _vm.id } },
    _vm._l(_vm.children, function(child) {
      return _c(
        "div",
        { key: child.id, staticClass: "rows__row" },
        [
          _c(_vm.getComponentVue(child.id), {
            tag: "component",
            attrs: { id: child.id }
          })
        ],
        1
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }